const data: any = {
  func: { loginHost: "https://passport.jd.com/new/login.aspx", apiHost: "//joshome.jd.com" },
  style: {},
  data: {},
  _clstag_: "jdzeus_powercenterdetail_zeus_zeus_zeus_power_center_detail",
};
export default data;
